import { NgModule } from '@angular/core';
import { BuildingBlockModule } from './component/building-block/building-block.module';
import { CustomPagesModule } from './component/custom-pages/custom-pages.module';
import { DynamicAppComponent } from './dynamic-app.component';
import { CustomCardsModule } from './component/custom-cards/custom-cards.module';

@NgModule({
  declarations: [DynamicAppComponent],
  exports: [],
  imports: [BuildingBlockModule, CustomPagesModule, CustomCardsModule],
  providers: []
})
export class DynamicAppModule {}
